import { useEffect } from 'react';
import { collection, query, where, getDocs, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../firebase/config';

export default function useNotificationsAuto(user) {
  useEffect(() => {
    if (!user) return;

    const verifierNotifications = async () => {
      const aujourdhui = new Date();
      aujourdhui.setHours(0, 0, 0, 0);
      const clejour = aujourdhui.toISOString().slice(0, 10);

      try {
        const qActions = query(
          collection(db, 'actions'),
          where('statut', '==', 'A FAIRE')
        );
        const snap = await getDocs(qActions);

        for (const docSnap of snap.docs) {
          const action = { id: docSnap.id, ...docSnap.data() };

          if (user.role !== 'manager' && action.commercialId !== user.uid) continue;

          const destinataireId = user.uid;
          const dateAction = action.dateAction?.toDate
            ? action.dateAction.toDate()
            : new Date(action.dateAction);

          // 1. Actions en retard
          if (dateAction < aujourdhui) {
            const cleDoublon = `retard_${action.id}_${clejour}`;
            const qExist = query(
              collection(db, 'notifications'),
              where('cleDoublon', '==', cleDoublon),
              where('destinataireId', '==', destinataireId)
            );
            const exist = await getDocs(qExist);
            if (exist.empty) {
              await addDoc(collection(db, 'notifications'), {
                destinataireId,
                titre: '⚠️ Action en retard',
                message: `Action "${action.action}" pour ${action.clientNom} était prévue le ${dateAction.toLocaleDateString('fr-FR')}.`,
                type: 'retard',
                actionId: action.id,
                cleDoublon,
                lu: false,
                createdAt: Timestamp.now()
              });
            }
          }

          // 2. Rappels du jour — priorité aux dates calculées (rappelsDates),
          // sinon on tente l'ancien format en ignorant les valeurs invalides
          const sourcesRappels = Array.isArray(action.rappelsDates) && action.rappelsDates.length > 0
            ? action.rappelsDates
            : (Array.isArray(action.rappels) ? action.rappels : []);
          if (sourcesRappels.length > 0) {
            for (const rappel of sourcesRappels) {
              const dateRappel = rappel?.toDate ? rappel.toDate() : new Date(rappel);
              if (isNaN(dateRappel.getTime())) continue; // libellé non convertible → ignorer
              dateRappel.setHours(0, 0, 0, 0);
              if (dateRappel.getTime() === aujourdhui.getTime()) {
                const cleDoublon = `rappel_${action.id}_${clejour}`;
                const qExist = query(
                  collection(db, 'notifications'),
                  where('cleDoublon', '==', cleDoublon),
                  where('destinataireId', '==', destinataireId)
                );
                const exist = await getDocs(qExist);
                if (exist.empty) {
                  await addDoc(collection(db, 'notifications'), {
                    destinataireId,
                    titre: '🔔 Rappel aujourd\'hui',
                    message: `Rappel pour l'action "${action.action}" chez ${action.clientNom}.`,
                    type: 'rappel',
                    actionId: action.id,
                    cleDoublon,
                    lu: false,
                    createdAt: Timestamp.now()
                  });
                }
              }
            }
          }
        }
      } catch (err) {
        console.error('useNotificationsAuto:', err);
      }
    };

    verifierNotifications();
  }, [user?.uid]);
}
